import classNames from 'classnames';
import FilterButton, {
  FilterButtonProps,
} from '@/components/organisms/filter-button/filter-button';
import styles from './filter-button-list.module.scss';

export interface FilterButtonItem extends FilterButtonProps {
  id: string;
}

export interface FilterButtonListProps {
  /** The class name to apply */
  className?: string;
  /** Indicates whether the buttons stretch to fill the list */
  isFullWidth?: boolean;
  /** An array of the filter cards to show */
  items: FilterButtonItem[];
  /** An event that is triggered on click */
  onClick?: (id: string) => void;
}

const FilterButtonList = ({
  className,
  isFullWidth = false,
  items,
  onClick,
}: FilterButtonListProps) => {
  const handleClickButton = (id: string) => {
    onClick && onClick(id);
  };

  return (
    <div
      className={classNames(styles.component, className, {
        [styles.isFullWidth]: isFullWidth,
      })}
    >
      {items.map(
        item =>
          item && (
            <FilterButton
              key={item.id}
              className={styles.button}
              count={item.count}
              isFullWidth={isFullWidth}
              label={item.label}
              onClick={() => handleClickButton(item.id)}
              showIcon={item.showIcon}
            />
          ),
      )}
    </div>
  );
};

FilterButtonList.displayName = 'FilterButtonList';

export default FilterButtonList;
